export default __webpack_public_path__ + "static/media/33.2bbb0d43.png";